import PropTypes from 'prop-types';
import React from 'react';
import FlatButton from '../FlatButton';
import ArrowLeft from '../Icons/ArrowLeft';

const defaultStyles = {
    fontSize: '18px',
    lineHeight: '22px',
};

const BackButton = ({ btnStyles, title, link, className, containerStyles, disabled, ...props }) => (
    <div
        className={className}
        style={{ ...containerStyles }}
    >
        <FlatButton
            to={link}
            icon={ArrowLeft}
            style={{
                ...defaultStyles,
                ...btnStyles,
            }}
            disabled={disabled}
            {...props}
        >
            {title}
        </FlatButton>
    </div>
);

BackButton.propTypes = {
    btnStyles: PropTypes.object,
    containerStyles: PropTypes.object,
    title: PropTypes.string,
    link: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
};

BackButton.defaultProps = {
    containerStyles: {},
    btnStyles: {},
    title: 'Back',
};

export default BackButton;



// WEBPACK FOOTER //
// ./src/client/Components/BackButton/BackButton.js